import React from 'react';

export default function IndexSectionHowItWorksWhitePattern4() {
    return (
        <React.Fragment>
            <>
                <section className="py-24 bg-white overflow-hidden" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <div className="flex flex-wrap -mx-4">
      <div className="w-full md:w-1/2 px-4 mb-16 md:mb-0">
        <div className="relative mx-auto md:ml-0 max-w-max">
          <img className="absolute z-10 -right-8 -top-8 w-28 md:w-auto" src="flex-ui-assets/elements/circle3-yellow.svg" alt />
          <img className="absolute z-10 -left-10 -bottom-8 w-28 md:w-auto" src="flex-ui-assets/elements/dots3-blue.svg" alt />
          <img src="https://static.shuffle.dev/uploads/files/74/74d816bee2c29a5d66e5f8e50d060dc2753d3889/Fina-Flipchart.webp" alt />
        </div>
      </div>
      <div className="w-full md:w-1/2 px-4">
        <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-full shadow-sm">How it works</span>
        <h2 className="mb-12 text-4xl md:text-5xl leading-tight font-bold tracking-tighter">Wie funktioniert FINA</h2>
        <div className="flex flex-wrap -mx-4 text-center md:text-left">
          <div className="w-full md:w-1/2 px-4 mb-8">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-green-500 font-semibold rounded-full">1</div>
            <h3 className="mb-2 text-xl font-bold">Rechnungserfassung</h3>
            <p className="font-medium text-coolGray-500">Ich verarbeite Deine Rechnung. Strukturiert, unstrukturiert, in XML oder CSV-Format. Wenn Du willst, bekommst alles Rechnungsdaten schön aufbereitet oder ich erstelle gleich den Buchungssatz.</p>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-8">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-green-500 font-semibold rounded-full">2</div>
            <h3 className="mb-2 text-xl font-bold">Rechnungsüberprüfung</h3>
            <p className="font-medium text-coolGray-500">Die Rechnung wird nach deinen Vorgaben geprüft und freigegeben - manuell oder automatisch, inhaltlich und rechtlich.</p>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-8">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-green-500 font-semibold rounded-full">3</div>
            <h3 className="mb-2 text-xl font-bold">Kommunikation</h3>
            <p className="font-medium text-coolGray-500">Gerne sende ich Rechnungen zur Freigabe an Mitarbeitende. Manchmal erinnere ich auch deine Kollegen. Außerdem nehme ich Kontakt mit den Lieferanten auf, um Unstimmigkeiten oder fehlerhafte Rechnung zu besprechen.</p>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-white bg-green-500 font-semibold rounded-full">4</div>
            <h3 className="mb-2 text-xl font-bold">Prozessverbesserung</h3>
            <p className="font-medium text-coolGray-500">Mit der Zeit übernehme ich immer mehr Aufgaben, dein Umgang mit Kreditorenrechnungen wird immer strukturierter, robuster und schneller.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

